export { default } from './Switch';
export type { SwitchProps } from './Switch';
